import { createErrorLog } from "./actions";

export const logError = ({ error, message, isWarning = false, info = {} }) => {
  if (isWarning) {
    createErrorLog({ restInfo: info, warning: message });
    return;
  }

  let errCode = null;
  let errMsg = error?.message || undefined;
  if (error?.response) {
    const errRes = error.response?.data?.errors;
    errCode = error.response?.code;
    errMsg = errRes || error.response?.message || error.response.data;
  }

  createErrorLog({ errMsg, message, errCode, restInfo: info });
};
